import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Title", -1)


import useAssignedTraining from "@/components/useAssignedTraining.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingDialog',
  props: ["trainingId"],
  emits: ["closeSelf"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

const closeSelf = () => {
  emit("closeSelf");
};
const assignTraining = () => {
  useAssignedTraining.assignTraining(props.trainingId)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "absolute left-0 top-0 h-[100%] w-[100%] bg-gray-800 opacity-20",
      onClick: closeSelf
    }),
    _createElementVNode("div", { class: "absolute left-1/3 z-10 h-1/2 w-1/3 bg-white p-6" }, [
      _hoisted_1,
      _createElementVNode("button", { onClick: assignTraining }, "Assign to me")
    ])
  ], 64))
}
}

})